import { useState } from 'react'
import axios from 'axios'

import { API_BASE_URL } from '../config/api'

export const useMediaEditor = (eventId, onMediaUpdate, onError) => {
  const [editingDescription, setEditingDescription] = useState(null)
  const [editingName, setEditingName] = useState(null)
  const [newDescription, setNewDescription] = useState('')
  const [newName, setNewName] = useState('')
  const [loading, setLoading] = useState(false)

  const checkOwnership = (isOwner, action = 'edit') => {
    if (!isOwner) {
      onError(`You can only ${action} your own events`)
      return false
    }
    return true
  }

  const startEditDescription = (mediaItem, isOwner) => {
    if (!checkOwnership(isOwner)) return
    setEditingDescription(mediaItem._id)
    setNewDescription(mediaItem.description || '')
  }

  const startEditName = (mediaItem, isOwner) => {
    if (!checkOwnership(isOwner)) return
    setEditingName(mediaItem._id)
    setNewName(mediaItem.customName || mediaItem.originalName || '')
  }

  const updateMedia = async (mediaId, updateData, field) => {
    setLoading(true)
    try {
      const response = await axios.put(
        `${API_BASE_URL}/api/events/${eventId}/media/${mediaId}`,
        updateData,
        { withCredentials: true }
      )

      onMediaUpdate(response.data.event)

      if (field === 'description') {
        setEditingDescription(null)
        setNewDescription('')
      } else if (field === 'name') {
        setEditingName(null)
        setNewName('')
      }
    } catch (error) {
      if (process.env.NODE_ENV === 'development') console.error(`Error updating ${field}:`, error)
      onError(error.response?.data?.message || `Failed to update ${field}`)
    } finally {
      setLoading(false)
    }
  }

  const saveDescription = (mediaId) => {
    updateMedia(mediaId, { description: newDescription }, 'description')
  }

  const saveName = (mediaId) => {
    updateMedia(mediaId, { customName: newName }, 'name')
  }

  const cancelEdit = (type) => {
    if (type === 'name') {
      setEditingName(null)
      setNewName('')
    } else if (type === 'description') {
      setEditingDescription(null)
      setNewDescription('')
    }
  }

  return {
    editingDescription,
    editingName,
    newDescription,
    newName,
    loading,
    startEditDescription,
    startEditName,
    saveDescription,
    saveName,
    cancelEdit,
    setNewDescription,
    setNewName
  }
}